/**
 * 判断是否是移动端
 * @returns true: 是移动端; false: PC端
 */
export function isMobile() {
  var reg = /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i;
  return reg.test(navigator.userAgent.toLowerCase());
}